import { writable } from 'svelte/store';
import type { ToastPosition } from 'svoast';

export const userId = writable<string>(undefined);
export const toastPosition = writable<ToastPosition>(undefined);
export const sideNavOpen = writable<boolean>(false);
export const announcementsModalOpen = writable<boolean>(false);
export const notificationIds = writable<number[]>([]);
